import useSWR, { SWRConfiguration } from 'swr';
import { useLocalStorage } from '../../../../utils/useLocalStorage';
import { fetchService } from '../../../../utils/fetchService';

export function useFetchRuleSummaries(analysisId: string, options?: SWRConfiguration) {
  const [accessToken = ''] = useLocalStorage('accessToken', '');

  const { data, mutate } = useSWR(`/eval/results/${analysisId}/rule-summaries`, (url: string) => fetchService(url, accessToken), options);

  return {
    ruleSummariesData: data,
    reloadRuleSummariesData: mutate,
  };
}
